/**
 * Stable CSS class names for E2E — RuleServiceV2 CriteriaType tab.
 */
export const CTT = {
    root: 'criteria-type-tab',
    createButton: 'criteria-type-tab-input--button-create',
    gridSection: 'criteria-type-tab__grid-section',
    modalSection: 'criteria-type-tab__modal-section',
} as const;

export const cttCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

